import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/GLB_Teclado.glb";
// import { GUI } from "dat.gui";
import gsap from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";

export class Teclado extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.3, -0.99, -0.8)
		this.scale.set(2.3, 2.3, 2.3);
		this.rotateY(-1.57)
		this.listenersobserver()
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Teclado = gltf.scene.getObjectByName("Teclado", true);
			// Teclas
			this.S = gltf.scene.getObjectByName("Cube032", true);
		})
	}
	listenersobserver() {
		ObserverEmitter.on(EVENTS.tema5.subtopicOne.activityOne.animateKey, (key) => {
			this.onAnimate(this[key])
		});
		ObserverEmitter.on(EVENTS.tema5.subtopicOne.activityOne.clearKeyAnimation, (key) => {
			this.clearKeyAnimation(this[key])
		});
	}
	onAnimateKeyboard() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.Teclado
		this.Teclado.material.emissive.set("#404040");

		this.animation = gsap.to(this.Teclado.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	onAnimate(object) {
		this.clearKeyAnimation(object)

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		// this.objectActiveAnimation = object
		object.material.emissive.set("#404040");

		object.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
	clearKeyAnimation(object) {
		if (this.animation) {
			this.animation.kill();
		}
		if (object.animation) {
			object.animation.kill();
			object.material.emissive.set("#000000");
			object.material.emissiveIntensity = 0
		}
	}
}